var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTime = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "52px",
    viewBox: "0 0 52 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "894AB8FA-79F6-4407-960D-E453A5207D5E") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CNC---Cuisine",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Preparer---overview-select",
    transform: "translate(-30.000000, -33.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI/Header"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(30.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Atom/icons/time",
    transform: "translate(0.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26,0 C40.3378512,0 52,11.6621475 52,26 C52,40.3378525 40.3378512,52 26,52 C11.6621488,52 0,40.3378525 0,26 C0,11.6621475 11.6621488,0 26,0 Z M26,3.62790655 C13.6227907,3.62790655 3.62790698,13.6227891 3.62790698,26.000003 C3.62790698,38.3772109 13.6227907,48.3720934 26,48.3720934 C38.3771488,48.3720934 48.372093,38.3772109 48.372093,26.000003 C48.372093,13.6227891 38.3771488,3.62790655 26,3.62790655 Z M26,7.25581311 C27.001786,7.25581311 27.8139535,8.06798046 27.8139535,9.06976639 L27.8139535,26.000003 C27.8139535,26.6708634 27.4483814,27.2544726 26.9069767,27.568347 L13.2834605,35.4287508 C12.415907,35.9297042 11.309093,35.6350577 10.8081395,34.7674439 C10.3072465,33.8998905 10.6018326,32.7930162 11.469507,32.2921232 L24.1860465,24.9607892 L24.1860465,9.06976639 C24.1860465,8.06798046 24.9981535,7.25581311 26,7.25581311 Z"
  })))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTime);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/time.507ad81feb5f09a87b008467a6b023c7.svg";